import React from "react";

import {Dialog, DialogActionsBar} from '@progress/kendo-react-dialogs';

import acxiom from "../Segmentation/temporaryresources/docs/acxiom.csv";
import dma3 from "../Segmentation/temporaryresources/docs/dma3.csv";
import address from "../Segmentation/temporaryresources/docs/address.csv";
import anzu from "../Segmentation/temporaryresources/docs/anzu.csv";
import naics from "../Segmentation/temporaryresources/docs/naics.csv";
import uid2raw from "../Segmentation/temporaryresources/docs/uid2-raw.csv"
// import adstra from "../Segmentation/temporaryresources/docs/adstra.csv";
import audienceacuity from "../Segmentation/temporaryresources/docs/audienceacuity_id.csv";
import blockgraph from "../Segmentation/temporaryresources/docs/blockgraph_id.csv";
// import haddress from "../Segmentation/temporaryresources/docs/address.csv";
// import companyName from "../Segmentation/temporaryresources/docs/company_name.csv";
import company_name_and_naics from "../Segmentation/temporaryresources/docs/company_name_and_naics.csv";
import companyAddress from "../Segmentation/temporaryresources/docs/company_name_and_address.txt";
import dataaxle from "../Segmentation/temporaryresources/docs/dataaxle.csv";
import datatrust from "../Segmentation/temporaryresources/docs/datatrust_id.csv";
import deviceId from "../Segmentation/temporaryresources/docs/device_id.csv";
import domainName from "../Segmentation/temporaryresources/docs/domain_name.csv";
import email from "../Segmentation/temporaryresources/docs/email.csv";
import first_last_zip5 from "../Segmentation/temporaryresources/docs/first_last_zip5.csv"
import freewheel from "../Segmentation/temporaryresources/docs/freewheel_ids.csv";
import healthwise from "../Segmentation/temporaryresources/docs/healthwise_keys.csv";
import i360_id from "../Segmentation/temporaryresources/docs/i360_id.csv"
import impressions from "../Segmentation/temporaryresources/docs/impressions.csv";
import internetSites from "../Segmentation/temporaryresources/docs/internet_sites.csv";
import internetKeywords from "../Segmentation/temporaryresources/docs/internet_keywords.csv";
// FD:15284
// import L2DataVoter from "../Segmentation/temporaryresources/docs/l2_data_voter_id.csv";
import latLong from "../Segmentation/temporaryresources/docs/lat_long.csv";
// import map from "../Segmentation/temporaryresources/docs/geo.csv";
import md5Email from "../Segmentation/temporaryresources/docs/md5_email.csv";
import pdi from "../Segmentation/temporaryresources/docs/pdi_id.csv";
import npiId from "../Segmentation/temporaryresources/docs/npi_id.csv";
import personKey from "../Segmentation/temporaryresources/docs/person_key.csv";
import pubmatic from "../Segmentation/temporaryresources/docs/pubmatic_id.csv";
// import purplelab from "../Segmentation/temporaryresources/docs/PurpleLabID.csv";
import purplelabHouseHoldId from "../Segmentation/temporaryresources/docs/PurpleLabHouseholdId.csv";
import purplelabIndividualId from "../Segmentation/temporaryresources/docs/PurpleLabIndividualId.csv";
import semcastingid from "../Segmentation/temporaryresources/docs/persistent_id.csv";
import sha1Email from "../Segmentation/temporaryresources/docs/sha1_email.csv";
import sha256DeviceId from "../Segmentation/temporaryresources/docs/sha256_devices.csv";
import sha256Email from "../Segmentation/temporaryresources/docs/sha256_email.csv";
import sha256Phone from "../Segmentation/temporaryresources/docs/sha256-phones.csv";
import sha256SemcastingId from "../Segmentation/temporaryresources/docs/sha256_semcasting_id.csv";
import tahoeId from "../Segmentation/temporaryresources/docs/tahoe_id.csv"
import lgHhid from "../Segmentation/temporaryresources/docs/lg_hhid.csv"
import usPhone from "../Segmentation/temporaryresources/docs/us_phone.csv";
import voterId from "../Segmentation/temporaryresources/docs/voter_id.csv";
import xandrId from "../Segmentation/temporaryresources/docs/xandr_id.csv";
import zip11 from "../Segmentation/temporaryresources/docs/zip11.txt";
import zip5 from "../Segmentation/temporaryresources/docs/zip5.txt";
import zip9 from "../Segmentation/temporaryresources/docs/zip9.txt";

import {Button} from "@progress/kendo-react-buttons";
import {Label} from "@progress/kendo-react-labels";

import "./MatchKeys.css";

const MatchKeys = (props) => {

    return (
        <>
            {props.isOpenModel && (<Dialog modal={"false"} width={"30%"} height={"80%"} title={props.viewMode ? "Accepted Match Keys" : "Unknown Match Key"} className={"unknown-filetype-dialog"} closeIcon={false}>
                <div className={"unknown-filetype-notification"}>
                    {props.viewMode ? "" : <h5>We could not tell what type of file you uploaded.</h5>}
                    <Label className={"unknown-filetype-instructions"}>Please select a template to download from the list below, and ensure your data is formatted the same way,
                        or press <span onClick={props.handleClose} style={{cursor: 'pointer'}}>"OK"</span> and upload a different file.</Label>
                </div>
                <h5 className={"unknown-filetype-templates-text"}>Templates to Download: </h5>
                <div>
                    <ul className={"unknown-filetype-list-items"}>
                        <li><a href={zip11} download="zip11.csv">11 Digit Zip Codes</a></li>
                        <li><a href={dma3} download="dma3.csv">3 Digit DMA Code</a></li>
                        <li><a href={zip5} download="zip5.csv">5 Digit Zip Codes</a></li>
                        <li><a href={zip9} download="zip9.csv">9 Digit Zip Codes</a></li>
                        <li><a href={acxiom} download="acxiom.csv">Acxiom</a></li>
                        {/*<li><a href={anzu} download="anzu.csv">Anzu</a></li>*/}
                        {/*<li style={{pointerEvents: "none", opacity: "0.5"}}><a href={""} download="adstra_id.csv">Adstra*/}
                        {/*    Id</a></li>*/}
                        {/*<li><a href={audienceacuity} download="audienceacuity_id.csv">Audience Acuity ID</a></li>*/}
                        <li><a href={blockgraph} download="blockgraph_id.csv">Blockgraph ID</a></li>
                        <li><a href={companyAddress} download="company_name_address.csv">Business Name and Address</a>
                        </li>
                        <li><a href={company_name_and_naics} download="company_name_naics.csv">Business Name and
                            NAICS</a></li>
                        {/*Once we get a sample DataAxle file we can enable*/}
                        {/*<li><a href={dataaxle} download="dataaxle_id.csv">DataAxle ID</a></li>*/}
                        <li><a href={datatrust} download="datatrust_id.csv">DataTrust ID</a></li>
                        <li><a href={deviceId} download="device_id.csv">Device ID</a></li>
                        <li><a href={domainName} download="domain_name.csv">Domain Name</a></li>
                        <li><a href={email} download="email.csv">Plain Text Email</a></li>
                        <li><a href={first_last_zip5} download="first_last_zip5.csv">First and Last Name and
                            ZIP5</a></li>
                        <li><a href={freewheel} download="freewheel_ids.csv">FreeWheel ID</a></li>
                        <li><a href={address} download="humana_address.csv">Household Address</a></li>
                        {/*<li><a href={healthwise} download="healthwise_keys.csv">HealthWise ID</a></li>*/}
                        {/*<li><a href={i360_id} download="i360_id.csv">i360 ID</a></li>*/}
                        <li><a href={impressions} download="impressions.csv">IP and Timestamp</a></li>
                        <li><a href={internetKeywords} download="internet_keyword.csv">Keywords</a></li>
                        <li><a href={internetSites} download="internet_sites.csv">Log-File Traffic</a></li>
                        {/*FD:15284*/}
                        {/*<li><a href={L2DataVoter} download="l2data_voter_id.csv">L2Data Voter ID</a></li>*/}
                        {/*<li><a href={latLong} download="lat_long.csv">Lat/Lng</a></li>*/}
                        <li><a href={lgHhid} download="lg_hhid.csv">LG Ads ID</a></li>
                        <li><a href={md5Email} download="md5_email.csv">Md5 Email</a></li>
                        <li><a href={naics} download="naics.csv">NAICS Code</a></li>
                        <li><a href={npiId} download="npi_id.csv">NPI ID</a></li>
                        {/*<li><a href={pdi} download="pdi_id.csv">PDI ID</a></li>*/}
                        <li><a href={usPhone} download="us_phone.csv">Phone Number</a></li>
                        <li><a href={address} download="address.csv">Household Postal Address</a></li>
                        <li><a href={personKey} download="person_key.csv">Semcasting Individual ID</a></li>
                        <li><a href={pubmatic} download="pubmatic_id.csv">PubMatic ID</a></li>
                        {/*<li><a href={purplelab} download="purple-md5.csv">Purple Md5 ID</a></li>*/}
                        <li><a href={purplelabHouseHoldId} download="PurpleLabHouseholdId.csv">PurpleLab Household
                            ID</a></li>
                        <li><a href={purplelabIndividualId} download="PurpleLabIndividualId.csv">PurpleLab Individual
                            ID</a></li>
                        <li><a href={uid2raw} download="uid2-raw.csv">UID2</a></li>
                        <li><a href={semcastingid} download="persistent_id.csv">Semcasting Household ID</a></li>
                        <li><a href={sha1Email} download="sha1_email.csv">Sha1 Email</a></li>
                        <li><a href={sha256DeviceId} download="sha256_devices.csv">Sha256 Devices</a></li>
                        <li><a href={sha256Email} download="sha256_email.csv">Sha256 Email</a></li>
                        <li><a href={sha256Phone} download="sha256-phones.csv">Sha256 Phones</a></li>
                        <li><a href={sha256SemcastingId} download="sha256_semcasting_id.csv">Sha256 Semcasting ID</a>
                        </li>
                        {/*<li><a href={tahoeId} download="tahoe_id.csv">Tahoe ID</a></li>*/}
                        {/*<li><a href={voterId} download="voter_id.csv">Voter ID</a></li>*/}
                        <li><a href={xandrId} download="xandr_id.csv">Xandr ID</a></li>


                        {/*FD: 10026*/}
                        {/*<li><a href="/docs/geo.csv" download="geo.csv">Map</a></li>*/}
                        {/*<li><a href={map} download="geo.csv">Map</a></li>*/}


                        {/*<li><a href="/docs/datatrust_id.csv" download="datatrust_id.csv">DataTrust ID</a></li>*/}
                        {/*<li><a href={purplelab} download="purple-md5.csv">Purple Md5 ID</a></li>*/}
                        {/*<li><a href="/docs/voter_id.csv" download="voter_id.csv">Voter ID</a></li>*/}
                        {/*<li><a href="/docs/healthwise_id.csv" download="healthwise_id.csv">HW ID</a></li>*/}

                    </ul>
                </div>
                <DialogActionsBar layout={"end"}>
                <Button
                        className="dialog-save"
                        size="large"
                        onClick={() => {
                            props.handleClose()
                        }}>
                        OK
                    </Button>
                </DialogActionsBar>
            </Dialog>)}
        </>
    )
}

export default MatchKeys;
